'use strict';

require('../../style/index.less');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.8.1@antd/lib/message/style/index.js
// module id = 9
// module chunks = 0